import type { DocMigration } from "../docMigration";

const WALLS = "WALLS";
const WALL_ASSEMBLIES = "WALL_ASSEMBLIES";

const WALL_CORE = "WALL_CORE";
const WALL_SUBSTRATE = "WALL_SUBSTRATE";

function removeCategory(categories: string[], category: string): boolean {
  const index = categories.indexOf(category);
  if (index !== -1) {
    categories.splice(index, 1);
    return true;
  }
  return false;
}

function ensureCategory(categories: string[], category: string): void {
  if (!categories.includes(category)) {
    categories.push(category);
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_385: DocMigration = {
  maxSchemaVersion: "0.0.385",
  description: "Fix view template wall category migration",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];

      if (viewTemplate.viewType === "PLAN_VIEW") {
        removeCategory(viewTemplate.categories, WALLS);
        removeCategory(viewTemplate.categories, WALL_ASSEMBLIES);
        continue;
      }

      const revertWallCore = removeCategory(viewTemplate.categories, WALL_CORE);
      const revertWallSubstrate = removeCategory(viewTemplate.categories, WALL_SUBSTRATE);
      if (revertWallCore || revertWallSubstrate) {
        ensureCategory(viewTemplate.categories, WALLS);
      }

      if (viewTemplate.styleOverrides) {
        const wallOverride = viewTemplate.styleOverrides[WALL_CORE];
        const wallAssembliesOverride = viewTemplate.styleOverrides[WALL_SUBSTRATE];
        if (wallOverride || wallAssembliesOverride) {
          delete viewTemplate.styleOverrides[WALL_CORE];
          delete viewTemplate.styleOverrides[WALL_SUBSTRATE];
          viewTemplate.styleOverrides[WALLS] = { ...(wallOverride ?? {}), ...(wallAssembliesOverride ?? {}) };
        }
      }
    }
    return json;
  },
};

export default migration_0_0_385;
